exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-contact__content__submit.active[data-v-6fbd7a18]{background-color:#6c757d;pointer-events:none}", ""]);

// exports
